import { Injectable } from '@angular/core';
import { Toro } from '../../api/common/enumerations';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConsoleToggleService {

  constructor() {

  }

  disableConsoleInProduction(): void {
    //if (Toro.Environment.Prod) {
      console.warn('Console output is disabled on production!');
      console.log = function (): void { };
      console.debug = function (): void { };
      console.warn = function (): void { };
      console.info = function (): void { };
    //}
  }
}
